import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=08ede334&scoped=true&xmlns%3Av-slot=https%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=08ede334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ede334",
  null
  
)

export default component.exports